import React from 'react';

const Navigation = () =>{
    return (
        <nav style={{display: 'flex' , justifyContent:'flex-end'}}>
            <p className='f3 link b dim white pa3 pointer'>
            Version^1.0
            </p>
        </nav>
    );
}

export default Navigation;